<app-auth-container [backToRegister]="true">
  <img class="autentique-logo smartphone" src="/assets/logo-and-text-white.png" alt="" />
  <img class="autentique-logo tablet" src="/assets/Autentique.svg" alt="" />

  @if (isRawLogin()) {
    <p class="auth__title">{{ 'auth.signWith' | translate }}</p>
  }

  @if (shouldShowOauth()) {
    <div class="auth__methods forceDefaultColors">
      <app-google-oauth
        class="auth__methods-option"
        context="signin"
        uxMode="popup"
        type="standard"
        shape="rectangular"
        theme="outline"
        text="continue_with"
        size="large"
        width="235"
        logoAlignment="left"
        (callback)="login(AuthenticationMethod.Google, $event)"
      >
      </app-google-oauth>

      <div class="oauthHoverColor">
        <button type="button" class="auth__methods-option face" [disabled]="isLoading" (click)="login(AuthenticationMethod.Facebook)">
          <i class="fab fa-facebook"></i>
          <span>{{ 'auth.signWithFacebook' | translate }}</span>
        </button>
      </div>

      <div class="oauthHoverColor">
        <button type="button" class="auth__methods-option microsoft" [disabled]="isLoading" (click)="login(AuthenticationMethod.Microsoft)">
          <i class="fab fa-microsoft"></i>
          <span>{{ 'auth.signWithMicrosoft' | translate }}</span>
        </button>
      </div>
    </div>

    <div class="d-flex justify-content-center align-items-center hr">
      <hr class="m-0" />
      <p class="auth__alternative m-0">{{ 'auth.or' | translate }}</p>
    </div>
  }

  <form class="field__form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
    @if (loginStep === LoginStepEnum.Login) {
      <app-switch-tabs
        name="type"
        [options]="[
          [true, translateService.instant('auth.mail')],
          [false, translateService.instant('auth.phone')]
        ]"
        [(ngModel)]="loginByMail"
        [ngModelOptions]="{ standalone: true }"
      ></app-switch-tabs>
    }

    @if (isRawLogin()) {
      @if (loginByMail) {
        <label class="field__holder" [appFormControlWrap]="form.get('email')">
          <input type="email" class="field" formControlName="email" name="email" autocomplete="on" [appDisableInput]="loginStep !== LoginStepEnum.Login || isLoading" appValidEmail required />
          <span class="field__placeholder">{{ 'auth.mailAddress' | translate }}</span>
        </label>
      } @else {
        <label class="field__holder" [appFormControlWrap]="form.get('phone')">
          <app-phone-number
            inputClass="field"
            formControlName="phone"
            [appDisableInput]="[LoginStepEnum.SmsCode, LoginStepEnum.WhatsappCode].includes($any(loginStep))"
            name="phone"
            autocomplete="tel-national"
            appValidPhone
            required
          ></app-phone-number>

          <span class="field__placeholder">{{ 'documents.yourPhoneNumber' | translate }}</span>

          <small [hidden]="!form.get('phone').value || (!form.get('phone').hasError('phone') && !form.get('phone').hasError('userExistsError'))" class="text-danger">
            {{ 'error_invalid_phone_number' | translate }}
          </small>
        </label>
      }
    }

    @if (loginStep === LoginStepEnum.Password) {
      <label class="field__holder password" [appFormControlWrap]="form.get('password')">
        <input type="password" class="field" formControlName="password" name="password" autocomplete="current-password" required appShowPassword data-sentry-mask />
        <span class="field__placeholder">{{ 'auth.password' | translate }}</span>
      </label>

      @if (isRawLogin()) {
        <a routerLink="/recuperar-senha" queryParamsHandling="preserve" class="auth__recover">{{ 'auth.forgotPasswordQuestion' | translate }}</a>
      }
    }

    @if ([LoginStepEnum.SmsCode, LoginStepEnum.WhatsappCode].includes($any(loginStep))) {
      <label class="field__holder password" [appFormControlWrap]="form.get('phoneCode')">
        <input type="tel" class="field" formControlName="phoneCode" name="phoneCode" autocomplete="one-time-code" maxlength="6" appOnlyNumbers required />
        <span class="field__placeholder">{{ 'auth.confirmCode' | translate }}</span>
      </label>

      <div class="auth__descr auth__descr--small mt-3 mb-0">
        <div>
          {{
            phoneOtpProvider.translation('authCodeSent', currentPhoneOtpProvider)
              | translate
                : {
                    phoneValue: form.get('phone').value | phone$ | async
                  }
          }}
        </div>

        <div class="text-center whatsDiv">
          {{ 'auth.didNotReceiveCode' | translate }}

          <button
            type="button"
            class="btn btn-link whatsDiv__btn btnAnimatedBackground"
            [disabled]="isLoading || isSmsTimeout || timerService.isCountdownInProgress()"
            (click)="sendPhoneCode(form.get('phone').value, true); timeOutForAlternativeVerification()"
          >
            {{ 'auth.clickHereResend' | translate }}
          </button>
        </div>

        @if (hasPhoneOtpFallbackProvider()) {
          <div class="text-center whatsDiv">
            {{ 'auth.orTryBy' | translate }}

            <button
              type="button"
              class="btn btn-link btnAnimatedBackground"
              (click)="sendFallbackPhoneCode(form.get('phone').value); timeOutForAlternativeVerification()"
              [disabled]="isLoading || isSmsTimeout || timerService.isCountdownInProgress()"
            >
              <span class="whatsDiv__whatsapp">
                {{ phoneOtpFallbackProviderLabel() }} {{ (timerService.isCountdownInProgress() ? 'documents.in' : 'documents.clickingHere') | translate }}
                <div>&nbsp;{{ timerService.isCountdownInProgress() ? formattedTime : '' }}</div>
              </span>
            </button>
          </div>
        }
      </div>
    }

    @if (loginStep === LoginStepEnum.OtpCode) {
      <p class="auth__title w-100 text-center mb-2">{{ 'auth.otpStep.title' | translate }}</p>
      <div class="auth__descr auth__descr--small px-2 mb-0" [innerHTML]="'auth.otpStep.description' | translate"></div>

      <label class="field__holder mt-3" [appFormControlWrap]="form.get('otp')">
        <input type="tel" class="field" formControlName="otp" name="otp" autocomplete="one-time-code" maxlength="6" appOnlyNumbers required />
        <span class="field__placeholder">{{ 'auth.confirmCode' | translate }}</span>
      </label>
    }

    @if (loginStep === LoginStepEnum.MfaSelect) {
      <p class="auth__title w-100 text-center">{{ 'auth.mfaSelectStep.title' | translate }}</p>
      <div class="auth__descr auth__descr--small px-2">{{ 'auth.mfaSelectStep.description' | translate }}</div>

      @for (item of mfaOptions; track $index) {
        <label class="field__holder radio-option" [class.active]="form.get('mfaType').value === item.type">
          <input type="radio" name="mfaType" formControlName="mfaType" [value]="item.type" />
          {{ item.description | translate }}
        </label>
      }
    }

    @if (loginStep === LoginStepEnum.RecoveryCode) {
      <p class="auth__title w-100 text-center">{{ 'auth.otpRecoveryStep.title' | translate }}</p>
      <div class="auth__descr auth__descr--small px-2">{{ 'auth.otpRecoveryStep.description' | translate }}</div>

      <label class="field__holder" [appFormControlWrap]="form.get('recoveryCode')">
        <input type="text" class="field" formControlName="recoveryCode" name="recoveryCode" autocomplete="none" required />
        <span class="field__placeholder">{{ 'auth.otpRecoveryStep.input' | translate }}</span>
      </label>
    }

    @if (loginStep === LoginStepEnum.Register) {
      <div class="alertMessage size-S error mt-2">
        <i class="fa-regular fa-circle-exclamation"></i>
        <div>
          <span>{{ 'auth.' + (isValidEmail(form.get('email').value) ? 'accountNotFoundEmail' : 'accountNotFoundPhone') | translate }}</span>
        </div>
      </div>
    }

    @if (isSocialEmailAlreadyRegistered) {
      <div class="alertMessage size-S error mt-2">
        <i class="fa-regular fa-circle-exclamation"></i>
        <div>
          <span>
            {{ ('auth.existingAccountWithProvider' | translate) + ' ' + socialEmailProvider + ('auth.accessOrSetPassword' | translate) }}
            <a href="javascript:void(0)" class="auth__link" (click)="navigateToRecoveryPassword()">{{ 'auth.clickingHere' | translate }}</a>
          </span>
        </div>
      </div>
    }

    <div class="submit-holder">
      <button type="submit" class="submit btn-L btn-filled" [disabled]="isLoading || (isLoginProgressDisabled$ | async)">
        {{ ('auth.loginStep' | translate)[loginStep] || ('button.forward' | translate) }}
      </button>

      @if (loginStep !== LoginStepEnum.Login) {
        <button type="button" class="back btn-L btn-text" [disabled]="isLoading" (click)="back()">
          {{ 'button.back' | translate }}
        </button>
      }
    </div>
  </form>

  @if (isRawLogin()) {
    <a class="auth__link" (click)="navigateToRegister()">{{ 'auth.dontHaveAccRegistryHere' | translate }}</a>
  }

  @if (loginStep === LoginStepEnum.OtpCode) {
    <a href="javascript:void(0)" class="auth__link" (click)="changeLoginStep(LoginStepEnum.MfaSelect)">
      {{ 'auth.trySomethingElse' | translate }}
    </a>
  }

  @if (loginStep === LoginStepEnum.MfaSelect) {
    <a href="javascript:void(0)" class="auth__link" (click)="changeLoginStep(LoginStepEnum.RecoveryCode)">
      {{ 'auth.lostMfa' | translate }}
    </a>
  }
</app-auth-container>
